// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aces","colBig":"styles_colBig__-PehJ","colSmall":"styles_colSmall__2ji3j"};